
 <div class="slider">
  <owl-carousel-o [options]="customOptions">
    <ng-container>
        <ng-template carouselSlide *ngFor="let adsObj of this.adsList;trackBy: trackByImages;">           
            <div class="slide">
                <img [src]="adsObj.imageUrl" alt="AdsImage" loading="lazy" 
                class="img-fluid" width="450" height="160" fetchpriority="high">
            </div>
        </ng-template>  
    </ng-container>  
  </owl-carousel-o> 
  <div class="overlay" *ngIf ="marqueeText != null">
    <marquee direction="left">
      <h5>{{this.marqueeText.marqueeText}}</h5>
    </marquee>
  </div>
 </div>
 
  